/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VipDiscountCreateRequest } from '../../models/vip-discount-create-request';
import { VipDiscountCreateResponse } from '../../models/vip-discount-create-response';

export interface CreateVipDiscount$Params {
      body: VipDiscountCreateRequest
}

export function createVipDiscount(http: HttpClient, rootUrl: string, params: CreateVipDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<VipDiscountCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, createVipDiscount.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VipDiscountCreateResponse>;
    })
  );
}

createVipDiscount.PATH = '/discounts/vip';
